<template>
  <div class="license">
    <h1>{{ heading }}</h1>
    <p>
      Icons made by <a href="https://www.freepik.com/" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0 BY</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'License',
  data () {
    return {
      heading: 'License'
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/License.vue